import { Generic } from './Card';
export function isCard(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isCard;    //# sourceMappingURL=isCard.js.map
